import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import Popup from 'src/components/content/popup/popup';
import ContentWrapper from 'src/components/content/content-wrapper';

import styles from './modal.module.scss';
import ContentSection from 'src/components/content/content-section';
import colors from 'src/styles/equalution/colors';
import { Button } from 'reactstrap';
import TickGreen from 'src/assets/icons/tickGreen.svg';
import { useViewport } from 'src/lib/utils';
import moment from 'moment';
import { useChallengeProducts } from 'src/pages/subscription-new/hooks/useChallengeProducts';

interface Props {
  onClose: () => void;
}

export const AddonPurchaseConfirmation: FC<Props> = ({ onClose }) => {
  const { isMobile } = useViewport();

  const { challengeStartDate } = useChallengeProducts();

  const addCloseParamToUrl = () => {
    try {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('close', 'true');
      window.history.replaceState({}, '', currentUrl.toString());
    } catch (error) {
      console.error('Failed to add success parameter to URL:', error);
      try {
        const separator = window.location.href.includes('?') ? '&' : '?';
        const newUrl = `${window.location.href}${separator}success=true`;
        window.history.replaceState({}, '', newUrl);
      } catch (fallbackError) {
        console.error('Fallback method also failed:', fallbackError);
      }
    }
  };

  const handleClose = () => {
    addCloseParamToUrl();
    onClose();
  };

  return (
    <Popup onClose={handleClose}>
      <ContentWrapper className={styles.background}>
        <ContentSection className={styles.confirmContent} collapseAt="sm">
          <Button className={styles.close} onClick={handleClose} />

          <Stack alignItems={'center'} mt={3}>
            <img
              src={TickGreen}
              style={{ alignSelf: 'center' }}
              alt="success"
            />

            <Typography
              mt={2}
              fontSize={isMobile ? 24 : 32}
              fontWeight={700}
              color={colors.OFF_BLACK}
              textAlign="center"
              paddingX={'32px'}
              gutterBottom>
              Your subscription was successfully updated
            </Typography>

            <Typography
              mt={1}
              fontSize={20}
              fontWeight={600}
              color={colors.BLUEBERRY}
              textAlign="center"
              gutterBottom>
              Your transformation begins{' '}
              <span style={{ color: colors.SALAD }}>
                {challengeStartDate
                  ? moment(challengeStartDate).format('MMMM Do')
                  : ''}
                !
              </span>
            </Typography>
            <Button
              onClick={handleClose}
              size="sm"
              style={{ marginTop: '10px', width: '40%' }}
              variant="primary">
              Close
            </Button>
          </Stack>
        </ContentSection>
      </ContentWrapper>
    </Popup>
  );
};
